import {inject, Injectable} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {Amplify} from "aws-amplify";
import {Tokens} from "./auth.service";
import {fetchAuthSession, signOut} from "aws-amplify/auth";
import {cognitoUserPoolsTokenProvider} from "aws-amplify/auth/cognito";
import {StorageService} from "../storage.service";
import {AmplifyPreferencesStorage} from "./amplify-preferences-storage";
import {isNative} from "../../utils";

if (isNative) {
  cognitoUserPoolsTokenProvider.setKeyValueStorage(new AmplifyPreferencesStorage());
}

Amplify.configure(
  {
    Auth: {
      Cognito: {
        userPoolId: environment.cognitoUserPoolId,
        userPoolClientId: environment.cognitoUserPoolClientId,
        loginWith: {
          oauth: {
            domain: environment.cognitoOAuthDomain,
            scopes: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
            redirectSignIn: [
              'http://localhost:4200/callback',
              `${environment.baseUrl}/callback`,
            ],
            redirectSignOut: [
              environment.baseUrl,
              'http://localhost:4200',
            ],
            responseType: 'code'
          },
        }
      }
    }
  }
)

@Injectable({
  providedIn: 'root'
})
export class UsernamePasswordAuthService {
  private readonly storageService = inject(StorageService);
  constructor() {}

  public async getTokens(): Promise<Tokens | undefined> {
    const session = await fetchAuthSession();

    if (!session.tokens) {
      const priorAuthType = await this.storageService.getItem('AUTH_TYPE');
      console.warn('No tokens found in auth session, please login again', {
        priorAuthType,
        sessionKeys: Object.keys(session).join(',') || 'none',
        hasUserSub: !!session.userSub,
        hasIdentityId: !!session.identityId,
        hasCredentials: !!session.credentials,
      });
      await this.storageService.removeItem('AUTH_TYPE');
      return undefined;
    }

    if (!session.tokens.idToken) {
      console.error('No id token found in auth session, please login again');
      await this.storageService.removeItem('AUTH_TYPE');
      return undefined;
    }

    if (!session.tokens.accessToken) {
      console.error('No access token found in auth session, please login again');
      await this.storageService.removeItem('AUTH_TYPE');
      return undefined;
    }

    return {
      source: 'username-password',
      idToken: session.tokens.idToken.toString(),
      accessToken: session.tokens.accessToken.toString(),
    }
  }

  public async logout(): Promise<void> {
    await signOut();

  }
}
